/**
 * @fileoverview Create Prospect owner choices query hook.
 * @description Wraps GET /sales/prospects/eligible-owners in a TanStack query. Only a caller who
 * may assign an owner gets choices, so the query stays idle unless `enabled`.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getEligibleProspectOwners } from '@/features/sales/services/prospects.service'

/**
 * @description Fetches the Sales Executives the caller may name as a new prospect's owner.
 * @param {boolean} enabled - Whether to fetch at all.
 * @returns {ReturnType<typeof useQuery>} The query (data is the choices).
 */
export function useEligibleProspectOwners(enabled: boolean) {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.eligibleOwners,
    queryFn: getEligibleProspectOwners,
    enabled,
  })
}
